<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
       size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-center wrap>
      <v-flex xs12 pt-5>
        <v-card>
          <v-layout justify-start wrap pt-6>
            <v-layout justify-center wrap>
              <v-flex xs3 sm3 md3 pl-5 text-center>
               <v-img width="30px" src="./../../assets/images/class.svg"></v-img>
              </v-flex>
              <v-flex xs9 sm9 md9 text-left>
                <router-link :to="'/addClass'" style="text-decoration: none">
                  <span
                    style="
                      font-family: nunitosansbold;
                      font-size: 20px;
                      color: #000000;
                    "
                    >View Class</span
                  >
                </router-link>
              </v-flex>
            </v-layout>
            <v-flex xs6 sm6 md9>
              <router-link
                :to="'/addClassTeacher'"
                style="text-decoration: none"
              >
                <span
                  style="
                    color: #797979;
                    font-family: nunitosanssemibold;
                    font-size: 18px;
                  "
                  >Add Class</span
                >
              </router-link>
            </v-flex></v-layout>
          <v-card-text>
            <v-layout justify-start wrap>
              <v-flex xs12 sm6 md8 pa-2>
                <v-select
                  v-model="standard"
                  dense
                  style="font-family: nunitosanssemibold"
                  outlined
                  label="Class"
                  :items="standardArray"
                  item-text="name"
                  item-value="value"
                ></v-select>
              </v-flex>
              <!-- <v-flex xs12 sm6 md6 pa-2>
                <v-select
                  v-model="classAdd.division"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  label="Section"
                  :items="section"
                  item-text="divisionName"
                  item-value="_id"
                ></v-select>
              </v-flex> -->
              <!-- <v-flex xs12 sm6 md6 pa-2>
                <v-select
                  v-model="classAdd.classTeacher"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  label="Assign Class Teacher"
                  :items="teacher"
                  item-text="user.name"
                  item-value="_id"
                ></v-select>
              </v-flex> -->
              <!-- <v-flex xs12 sm6 md6 pa-2>
                <v-select
                  v-model="classAdd.classTeacherSubject"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  label="Subject"
                  :items="subject"
                  item-text="subjectName"
                  item-value="_id"
                ></v-select>
              </v-flex> -->
              <v-spacer></v-spacer>
              <v-flex xs12 sm6 md4 pb-8 pa-2 text-right>
                <v-btn
                  @click="getSearch()"
                  dark
                  block
                  style="font-family: nunitosanssemibold"
                  color="#9B8DFD"
                  >SEARCH</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-layout justify-center wrap pt-10 pb-5 v-if="classArray.length > 0">
          <v-flex xs12>
            <span style="font-family: nunitosansbold; font-size: 20px"
              >View Class</span
            ><br />
            <v-layout justify-center wrap>
              <v-flex xs12 v-for="(item, i) in classArray" :key="i">
                <v-flex xs12 py-5>
                  <span style="font-family: nunitosanssemibold"
                    >Class {{ item.standard.standardName }}</span>
                  <v-layout justify-start wrap>
                    <v-flex
                      xs12
                      sm6
                      md4
                      lg4
                      xl4
                      v-for="(list, index) in item.data"
                      :key="index"
                      pa-2>
                      <v-card>
                        <v-card-text>
                          <v-layout justify-center wrap>
                            <v-flex xs4 sm4 md4 lg3 pt-2>
                              <v-avatar
                                v-if="list.teacher"
                                style="cursor: pointer"
                                size="48">
                                <v-img
                                  width="40px"
                                  :src="mediaURL + list.teacher.user.photo"
                                ></v-img>
                              </v-avatar>
                            </v-flex>
                            <v-flex xs7 sm7 md7 lg8>
                              <router-link
                                :to="'/viewClass/' + list._id"
                                style="text-decoration: none">
                                <span
                                  style="
                                    color: #000000;
                                    font-family: nunitosansbold;
                                  "
                                  >{{ list.className }}</span
                                ><br />
                                <span
                                  v-if="list.teacher"
                                  style="
                                    color: #000000;
                                    font-family: nunitosanssemibold;
                                  "
                                  >{{ list.teacher.user.name }}</span
                                ><br />
                                <span
                                  v-if="list.teacher"
                                  style="
                                    color: #000000;
                                    font-family: nunitosansregular;
                                  "
                                  >{{
                                    list.teacher.teachingClasses[0].subject
                                      .subjectName
                                  }}</span>
                              </router-link>
                            </v-flex>
                            <v-flex xs1 pt-2>
                              <v-dialog v-model="list.delete" max-width="600px">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon size="15" v-on="on" v-bind="attrs"
                                    >mdi-close</v-icon >
                                </template>
                                <v-card>
                                  <v-card-title
                                    style="font-family: nunitosansregular">
                                    Are you sure you want to delete this class?
                                  </v-card-title>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="list.delete = false"
                                      >Cancel</v-btn>
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="deleteItem(list._id)"
                                      >OK</v-btn>
                                    <v-spacer></v-spacer>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
         <v-layout v-else justify-center wrap py-8>
            <v-flex xs12 text-center>
              <span
                style="
                  font-family: nunitosansregular;
                  color: #000000;
                  font-size: 14px;
                "
                >Oops !! No data found..</span
              >
            </v-flex>
          </v-layout>
        <div class="text-center" v-if="pages>1">
          <v-pagination
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
             color="#9B8DFD"
          ></v-pagination>
          <v-flex xs12 py-5>
            <span
              style="
                font-family: nunitosansregular;
                color: #4e4e4e;
                font-size: 12px;
              "
              >Four Classes Per Page</span>
          </v-flex>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      hover: false,
      appLoading: false,
      showsnackbar: false,
      ServerError: false,
      msg: "",
      timeout: 5000,
      currentPage: 1,
      pages: 0,
      count: 4,
      totalData: 0,
      standard: "",
      // classAdd: {
      //   division: "",
      //   classTeacher: "",
      //   classTeacherSubject: "",
      // },
      studentList: [],
      page: 1,
      classArray: [],
      editingitem: [],
      standardArray: [],
      section: [],
      teacher: [],
      subject: [],
    };
  },
  watch: {
    currentPage() {
      this.getClass();
    },
  },
  mounted() {
    this.getStandard();
    this.getSection();
    this.getTeacher();
    this.getSubject();
    this.getClass();
  },
  methods: {
    
    getSearch() {
      this.appLoading = true;
      if(this.currentPage>1)
      this.currentPage=1
      axios({
        method: "GET",
        url: "/class/getlistgrouped",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
          standard: this.standard,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.classArray = response.data.data;
            this.pages = response.data.pages;
            this.totalData = response.data.count;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getClass() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/class/getlistgrouped",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
          standard: this.standard,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.classArray = response.data.data;
            this.pages = response.data.pages;
            this.totalData = response.data.count;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSubject() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/subject/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.subject = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getStandard() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/standard/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
           var temp = [
            {
              name: null,
              value: null,
            },
          ];
          temp = response.data.data;
          for (var i = 0; i < temp.length; i++) {
            temp[i].name = temp[i].standardName;
            temp[i].value = temp[i]._id;
          }
          this.standardArray = temp;
          this.standardArray.unshift({ name: "All", value: null });
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSection() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/division/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.section = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getTeacher() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/teacher/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.teacher = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteItem(r) {
      var data = {};
      data["id"] = r;
      axios({
        url: "/class/remove",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            console.log(r, "haiiii");
            this.showsnackbar = true;
            this.getClass();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>